/** B 端浏览器路由前缀（与 /merchant-api、views/merchant 目录无关） */
export const STORE_BASE = '/store'
export const LEGACY_MERCHANT_BASE = '/merchant'

/** `/workbench` → `/store/workbench`；已是绝对路径则原样规范化前缀 */
export function storePath(suffix: string): string {
  if (!suffix) return STORE_BASE
  if (suffix.startsWith(STORE_BASE)) return suffix
  if (suffix.startsWith(LEGACY_MERCHANT_BASE)) {
    return STORE_BASE + suffix.slice(LEGACY_MERCHANT_BASE.length)
  }
  const s = suffix.startsWith('/') ? suffix : `/${suffix}`
  return STORE_BASE + s
}

export function isStorePath(path: string): boolean {
  return path === STORE_BASE || path.startsWith(`${STORE_BASE}/`)
}

export function isLegacyMerchantPath(path: string): boolean {
  return path === LEGACY_MERCHANT_BASE || path.startsWith(`${LEGACY_MERCHANT_BASE}/`)
}

/** 旧 /merchant/* → /store/*（保留 query/hash 由调用方处理） */
export function legacyMerchantToStore(path: string): string {
  if (!isLegacyMerchantPath(path)) return path
  return STORE_BASE + path.slice(LEGACY_MERCHANT_BASE.length)
}
